import { useQuery } from "@tanstack/react-query";
import { Brand } from "entities/brands/types";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "shared/api/firebase";

export const getQueryKey = () => {
  return ["freeToPlayMainPage"];
};

export const useFreeToPlayMainPage = () => {
  return useQuery({
    queryKey: getQueryKey(),
    queryFn: async () => {
      const pagesCollectionRef = collection(db, "brands/free/pages");

      const q = query(pagesCollectionRef, where("path", "==", "home"));

      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        return null;
      }

      const doc = querySnapshot.docs[0];
      return {
        id: doc.id,
        ...doc.data(),
      } as Brand;
    },
  });
};
